/* PreSleep bundle PDP: tile pricing, perks, and the mix-and-match flavor picker.
   Every number comes from the section JSON (variant price, Recharge plans) and the tile percentages,
   which must mirror what the cart charges. Nothing here is a typed price. */
(function () {
  if (window.__psFlavorPicker) return;
  window.__psFlavorPicker = true;

  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
  }
  function unit(list, pct) { return Math.round(list * (100 - pct) / 100); }

  function Bundle(root) {
    this.root = root;
    try { this.d = JSON.parse(root.querySelector('[data-ps-bundle-json]').textContent); } catch (e) { return; }
    var d = this.d;
    this.flavors = d.flavors || [];
    this.tiles = Array.prototype.map.call(root.querySelectorAll('[data-tier]'), function (el) {
      return { el: el, jars: +el.dataset.jars, pct: +el.dataset.pct, track: el.dataset.track };
    });
    this.byJars = this.tiles.slice().sort(function (a, b) { return a.jars - b.jars; });
    this.sel = this.tiles[d.defaultTier] || this.tiles[0];
    this.fp = root.querySelector('[data-ps-fp]');
    this.counts = {};
    this.mode = 'sub';
    var self = this;
    this.tiles.forEach(function (t) { t.el.addEventListener('click', function () { self.pick(t); }); });
    root.querySelectorAll('[data-open-picker]').forEach(function (b) {
      b.addEventListener('click', function () { self.open(b.dataset.mode || 'sub', b); });
    });
    if (this.fp) this.wirePicker();
    this.renderOffer();
    this.guard();
  }

  Bundle.prototype.lead = function () {
    var d = this.d, f = this.flavors;
    var want = f.filter(function (x) { return x.key === d.defaultFlavor; })[0];
    if (want && want.available) return want;
    return f.filter(function (x) { return x.available; })[0] || want || f[0];
  };
  Bundle.prototype.tierFor = function (n) {
    var t = this.byJars[0];
    this.byJars.forEach(function (x) { if (n >= x.jars) t = x; });
    return t;
  };
  Bundle.prototype.oncePct = function (n) { var p = this.d.oncePct || []; return n >= 3 ? (p[3] || 0) : (p[n] || 0); };
  // The Recharge plan whose interval matches the bundle size (2 jars → 60 days). Bigger bundles than any
  // plan (4–6 jars) take the longest plan that fits; otherwise the monthly plan.
  Bundle.prototype.plan = function (f, n) {
    var ps = (f && f.plans) || [];
    var want = n * 30, exact = ps.filter(function (p) { return p.days === want; })[0];
    if (exact) return exact;
    var fit = ps.filter(function (p) { return p.days <= want; }).sort(function (a, b) { return b.days - a.days; })[0];
    return fit || ps.filter(function (p) { return p.days === 30; })[0] || ps[0] || null;
  };
  Bundle.prototype.days = function (n) { var p = this.plan(this.lead(), n); return p ? p.days : 30; };
  Bundle.prototype.nightly = function (total, n) { return total / Math.max(1, n * (this.d.nights || 30)); };
  // One-time: Shopify's automatic % comes off each jar, rounded down to the cent (checked: 2 jars = $85.00, 3 = $120.00).
  Bundle.prototype.onceUnit = function (price, n) { return price - Math.floor(price * this.oncePct(n) / 100); };
  Bundle.prototype.onceTotal = function (list, n) { return this.onceUnit(list, n) * n; };

  Bundle.prototype.pick = function (t) {
    this.sel = t;
    this.renderOffer();
  };

  Bundle.prototype.renderOffer = function () {
    var self = this, d = this.d, list = d.list, t = this.sel;
    if (!t) return;
    var str = d.str || {};
    this.tiles.forEach(function (x) {
      var on = x === t, tot = unit(list, x.pct) * x.jars, lst = list * x.jars;
      x.el.classList.toggle('is-on', on);
      x.el.setAttribute('aria-checked', on ? 'true' : 'false');
      var q = function (s) { return x.el.querySelector(s); };
      if (q('[data-t-list]')) q('[data-t-list]').textContent = money(lst);
      if (q('[data-t-total]')) q('[data-t-total]').textContent = money(tot);
      if (q('[data-t-night]')) q('[data-t-night]').textContent = money(self.nightly(tot, x.jars));
      if (q('[data-t-off]')) q('[data-t-off]').textContent = x.pct + '%';
      var bd = q('[data-t-badge]');
      if (bd) bd.textContent = fill(bd.dataset.tpl, { save: money(lst - tot).replace(/\.00$/, '') });
    });
    var total = unit(list, t.pct) * t.jars, lst = list * t.jars, days = this.days(t.jars);
    var map = { off: t.pct + '%', days: days, list: money(lst), total: money(total), jars: t.jars, pernight: money(this.nightly(total, t.jars)),
      onetime: money(this.onceTotal(list, t.jars)) };
    this.root.querySelectorAll('[data-fill]').forEach(function (el) { el.textContent = fill(el.dataset.tpl, map); });
    var cl = this.root.querySelector('[data-cta-list]'), ct = this.root.querySelector('[data-cta-total]');
    if (cl) { cl.textContent = money(lst); cl.hidden = lst <= total; }
    if (ct) ct.textContent = money(total);
    var fs = d.freeShip || 0, fsTile = null;
    this.byJars.forEach(function (x) { if (!fsTile && fs && unit(list, x.pct) * x.jars >= fs) fsTile = x; });
    this.root.querySelectorAll('[data-perk]').forEach(function (p) {
      var on;
      if (p.dataset.rule === 'free_ship') {
        on = !!fs && total >= fs;
        var at = p.querySelector('[data-perk-at]'), tl = fsTile && fsTile.el.querySelector('.ps-bm__tl');
        if (at && tl) at.textContent = tl.textContent;
      } else on = t.jars >= +p.dataset.unlock;
      p.classList.toggle('is-on', on);
      var s = p.querySelector('[data-perk-state]');
      if (s) s.textContent = on ? str.unlocked : str.locked;
    });
  };

  // Theme editor only: say so when the base tile disagrees with the live Recharge plan.
  Bundle.prototype.guard = function () {
    var g = this.root.querySelector('[data-ps-guard]');
    if (!g) return;
    var f = this.lead(), t1 = this.byJars[0], p = this.plan(f, 1), msgs = [];
    if (!p) msgs.push('No Recharge subscription plan found on ' + (f ? f.name : 'the product') + '. Subscribe adds will fail.');
    else if (t1 && p.first !== t1.pct) msgs.push('The ' + t1.jars + '-jar tile says ' + t1.pct + '% off, but the live Recharge plan gives ' + p.first + '% on the first order. The cart will charge ' + p.first + '%.');
    var extra = this.byJars.filter(function (x) { return p && x.pct > p.first; });
    if (extra.length) msgs.push('Tiles above ' + (p ? p.first : 0) + '% (' + extra.map(function (x) { return x.jars + ' jars ' + x.pct + '%'; }).join(', ') + ') only match the cart if a Shopify automatic discount adds the difference on subscription lines.');
    var noCad = this.byJars.filter(function (x) { return x.jars > 1 && (!p || this.plan(f, x.jars).days !== x.jars * 30); }, this);
    if (noCad.length) msgs.push('No ' + noCad.map(function (x) { return (x.jars * 30) + '-day'; }).join(' / ') + ' Recharge plan yet, so multi-jar subscriptions ship every ' + (p ? p.days : 30) + ' days.');
    if (!msgs.length) return;
    g.hidden = false;
    g.innerHTML = '<strong>Editor check (customers never see this):</strong> ' + msgs.map(function (m) { return '<span>' + m.replace(/</g, '&lt;') + '</span>'; }).join(' ');
  };

  /* ---------------- picker ---------------- */
  Bundle.prototype.wirePicker = function () {
    var self = this, fp = this.fp;
    fp.querySelectorAll('[data-fp-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
    fp.querySelectorAll('[data-fp-card]').forEach(function (card) {
      var key = card.dataset.fpCard;
      card.querySelector('[data-fp-minus]').addEventListener('click', function () { self.step(key, -1); });
      card.querySelector('[data-fp-plus]').addEventListener('click', function () { self.step(key, 1); });
    });
    fp.querySelector('[data-fp-cta]').addEventListener('click', function () { self.add(); });
    fp.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(fp.querySelectorAll('button:not([disabled])'), function (b) { return b.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    // Stops: built once from the tiles, priced per mode in renderPicker.
    var dots = fp.querySelector('[data-fp-dots]'), stops = fp.querySelector('[data-fp-stops]');
    this.byJars.forEach(function (t, i) {
      var dot = document.createElement('span');
      dot.className = 'ps-fp__dot';
      dot.style.left = (self.byJars.length > 1 ? (i / (self.byJars.length - 1)) * 100 : 50) + '%';
      dots.appendChild(dot);
      var st = document.createElement('span');
      st.className = 'ps-fp__stop';
      st.innerHTML = '<b></b><span></span>';
      st.querySelector('b').textContent = t.track || (t.jars + '');
      stops.appendChild(st);
    });
  };

  Bundle.prototype.open = function (mode, opener) {
    if (!this.fp) return;
    this.mode = mode === 'once' ? 'once' : 'sub';
    this.opener = opener;
    var n = this.sel ? this.sel.jars : 1, lead = this.lead(), self = this;
    this.counts = {};
    this.flavors.forEach(function (f) { self.counts[f.key] = 0; });
    if (lead && lead.available) this.counts[lead.key] = n;
    this.err('');
    var note = this.fp.querySelector('[data-fp-mode]');
    if (note) note.hidden = this.mode !== 'once';
    this.fp.hidden = false;
    document.documentElement.classList.add('ps-fp-lock');
    void this.fp.offsetHeight; // commit the closed state so the sheet slides in
    this.fp.classList.add('is-open');
    this.renderPicker();
    var x = this.fp.querySelector('.ps-fp__x');
    if (x) x.focus({ preventScroll: true });
    // Opening the selector puts the pre-selected jars in the cart: a real add to cart, so Shopify
    // reports AddToCart to Meta (pixel + Conversions API) at this step (Dylan, Oct 2026).
    this.leaving = false;
    this.sync().catch(function (e) { self.err((e && (e.description || e.message)) || (self.d.str || {}).error); });
  };

  Bundle.prototype.close = function () {
    if (!this.fp || this.fp.hidden) return;
    var fp = this.fp, self = this;
    if (!this.leaving) this.sync().catch(function () {});
    fp.classList.remove('is-open');
    document.documentElement.classList.remove('ps-fp-lock');
    setTimeout(function () { fp.hidden = true; }, 220);
    if (this.opener) this.opener.focus({ preventScroll: true });
  };

  Bundle.prototype.total = function () { var c = this.counts, n = 0; for (var k in c) n += c[k]; return n; };

  Bundle.prototype.step = function (key, dir) {
    var f = this.flavors.filter(function (x) { return x.key === key; })[0];
    if (!f) return;
    var max = this.d.maxJars || 6, str = this.d.str || {};
    if (dir > 0) {
      if (!f.available) return;
      if (this.total() >= max) { this.err(fill(str.max, { max: max })); return; }
    }
    this.err('');
    this.counts[key] = Math.max(0, (this.counts[key] || 0) + dir);
    this.renderPicker();
  };

  // What the cart will charge for the current picks.
  Bundle.prototype.quote = function () {
    var n = this.total(), self = this, pct, sum = 0;
    if (this.mode === 'sub') {
      pct = n ? this.tierFor(n).pct : 0;
      this.flavors.forEach(function (f) { sum += unit(f.price, pct) * (self.counts[f.key] || 0); });
    } else {
      pct = this.oncePct(n);
      this.flavors.forEach(function (f) { sum += self.onceUnit(f.price, n) * (self.counts[f.key] || 0); });
    }
    return { n: n, pct: pct, total: sum };
  };

  Bundle.prototype.renderPicker = function () {
    var fp = this.fp, d = this.d, str = d.str || {}, q = this.quote(), n = q.n, self = this, max = d.maxJars || 6;
    var jw = n === 1 ? str.jar : str.jars;
    fp.querySelectorAll('[data-fp-card]').forEach(function (card) {
      var k = card.dataset.fpCard, c = self.counts[k] || 0, f = self.flavors.filter(function (x) { return x.key === k; })[0];
      card.querySelector('[data-fp-count]').textContent = c;
      card.classList.toggle('is-picked', c > 0);
      card.querySelector('[data-fp-minus]').disabled = c <= 0;
      card.querySelector('[data-fp-plus]').disabled = !(f && f.available) || n >= max;
    });
    fp.querySelector('[data-fp-head]').textContent = n ? fill(str.head, { n: n, jars: jw }) : str.headEmpty;
    var pn = money(this.nightly(q.total, n));
    fp.querySelector('[data-fp-save]').textContent = n ? (q.pct > 0 ? fill(str.save, { off: q.pct + '%', pernight: pn }) : fill(str.saveNone, { pernight: pn })) : '';
    // Track: which tier the picks land in, and each stop's nightly price in this mode.
    var lead = this.lead(), list = lead ? lead.price : d.list, idx = -1;
    this.byJars.forEach(function (t, i) { if (n >= t.jars) idx = i; });
    var stopEls = fp.querySelectorAll('.ps-fp__stop'), dotEls = fp.querySelectorAll('.ps-fp__dot');
    this.byJars.forEach(function (t, i) {
      var tot = self.mode === 'sub' ? unit(list, t.pct) * t.jars : self.onceTotal(list, t.jars);
      stopEls[i].querySelector('span').textContent = money(self.nightly(tot, t.jars)) + '/night';
      stopEls[i].classList.toggle('is-on', i === idx);
      dotEls[i].classList.toggle('is-on', i <= idx);
    });
    var span = this.byJars.length > 1 ? this.byJars.length - 1 : 1;
    fp.querySelector('[data-fp-fill]').style.width = (Math.max(0, idx) / span * 100) + '%';
    var cta = fp.querySelector('[data-fp-cta]');
    if (!cta.dataset.busy) {
      cta.disabled = !n;
      cta.textContent = n ? fill(str.cta, { n: n, jars: jw, total: money(q.total) }) : str.ctaEmpty;
    }
  };

  Bundle.prototype.err = function (m) { var e = this.fp && this.fp.querySelector('[data-fp-err]'); if (e) e.textContent = m || ''; };

  Bundle.prototype.add = function () {
    var self = this, n = this.total(), str = this.d.str || {}, cta = this.fp.querySelector('[data-fp-cta]');
    if (!n || cta.dataset.busy) return;
    this.err('');
    cta.dataset.busy = '1';
    cta.disabled = true;
    cta.textContent = str.adding;
    this.leaving = true;
    this.sync().then(function () {
      if (self.d.after !== 'drawer') {
        // Straight to checkout (Dylan, Oct 2026). The short pause lets the browser pixel finish sending.
        setTimeout(function () { window.location.href = '/checkout'; }, 400);
        return;
      }
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        delete cta.dataset.busy;
        self.renderPicker();
        self.close();
        self.cartUpdated(cart);
      });
    }).catch(function (e) {
      self.leaving = false;
      delete cta.dataset.busy;
      self.renderPicker();
      self.err((e && (e.description || e.message)) || str.error);
    });
  };

  /* ---------------- cart sync ----------------
     The picker owns the cart lines for the flavor products: one line per picked flavor, on the
     Recharge plan for the bundle size (or no plan for one-time). Lines it doesn't want are removed,
     plan/quantity drops are changed in place, and anything missing is added with /cart/add.js,
     which is what Shopify reports as AddToCart. Other products in the cart are never touched. */
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: JSONH, body: JSON.stringify(body) }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  // Keep UpCart's drawer shut while the picker edits the cart (it opens on every add otherwise).
  var quietUntil = 0;
  function quiet(ms) {
    quietUntil = Date.now() + ms;
    var cur = window.upcartShouldSkipAddToCart;
    if (cur && cur.__ps) return;
    var wrapped = function (e) { return Date.now() < quietUntil || (typeof cur === 'function' ? cur(e) : false); };
    wrapped.__ps = true;
    window.upcartShouldSkipAddToCart = wrapped;
  }

  Bundle.prototype.target = function () {
    var self = this, n = this.total(), out = [];
    this.flavors.forEach(function (f) {
      var c = self.counts[f.key] || 0;
      if (!c || !f.available) return;
      var p = self.mode === 'sub' ? self.plan(f, n) : null;
      out.push({ variant: Number(f.variant), plan: p ? Number(p.id) : null, qty: c });
    });
    return out;
  };

  Bundle.prototype.sync = function () {
    var self = this, want = this.target();
    this.syncing = (this.syncing || Promise.resolve()).catch(function () {}).then(function () { return self.applyCart(want); });
    return this.syncing;
  };

  Bundle.prototype.applyCart = function (want) {
    var ids = this.flavors.map(function (f) { return Number(f.variant); }), guard = 0;
    quiet(4000);
    function step() {
      if (++guard > 12) return Promise.resolve();
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var lines = cart.items.filter(function (it) { return ids.indexOf(it.variant_id) > -1; }).map(function (it) {
          return { key: it.key, variant: it.variant_id, plan: it.selling_plan_allocation ? Number(it.selling_plan_allocation.selling_plan.id) : null, qty: it.quantity };
        });
        var seen = {};
        for (var i = 0; i < lines.length; i++) {
          var L = lines[i], w = want.filter(function (x) { return x.variant === L.variant; })[0];
          var keep = w && !seen[L.variant] && ((w.plan === null) === (L.plan === null));
          if (!keep) return post('/cart/change.js', { id: L.key, quantity: 0 }).then(step);
          seen[L.variant] = true;
          if (w.plan !== null && L.plan !== w.plan) return post('/cart/change.js', { id: L.key, quantity: L.qty, selling_plan: w.plan }).then(step);
          if (L.qty > w.qty) return post('/cart/change.js', { id: L.key, quantity: w.qty }).then(step);
        }
        var adds = [];
        want.forEach(function (w) {
          var L = lines.filter(function (l) { return l.variant === w.variant; })[0], have = L ? L.qty : 0;
          if (w.qty > have) {
            var it = { id: w.variant, quantity: w.qty - have };
            if (w.plan) it.selling_plan = w.plan;
            adds.push(it);
          }
        });
        if (adds.length) return post('/cart/add.js', { items: adds });
      });
    }
    return step().then(function () {
      quiet(1500);
      try { if (window.upcartRefreshCart) window.upcartRefreshCart(); } catch (e) {}
    });
  };

  Bundle.prototype.cartUpdated = function (cart) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('ps:cart-updated', { bubbles: true, detail: { cart: cart } }));
    document.querySelectorAll('[data-ps-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
    if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; }
    if (typeof window.openCart === 'function') { window.openCart(); return; }
    window.location.href = '/cart';
  };

  function boot(scope) {
    scope.querySelectorAll('[data-ps-bundle]').forEach(function (r) {
      if (r.dataset.ready) return;
      r.dataset.ready = '1';
      r.psBundle = new Bundle(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
